import { submissionPercentage, orderedListSlide, retrospectiveIntroduction } from '../Slides/SLSprint00'
import { breakoutStandard, tPrework } from './SLSprint00'
import { tPreworkWithLogo, basicSlideWithLogo, agendaSlide, basicSlide } from '../Slides/SLSprint00'

import { checklistAnnouncementsPreworkAndAgenda, completeDeck, tLab, makeSlideDeck } from './SL00000Sprint00'
import { insertInto } from './SLSprintPlanning'

import { xyz_n_5of6, xyz_n_6of6 } from './SL00000Sprint00'

import { se_7_1of6_PAaA } from './SL44000Sprint07'
import { sprintPlanningSlideDeck } from './SLSprintPlanning'

import { list44000Sprint05 } from '../ActivityLists/AL44000Sprint05'
import { list44000Sprint06 } from '../ActivityLists/AL44000Sprint06'
import { bulletListSlide } from './SLSprint00'
import { tDiscussionBreakout } from './SLSprint00'

import { sprintDemosIntro, sprintDemos, demoAssignment } from './SLSprint00'

// Sprint 6 Software Engineering (SE) global values.
const sprint = 6
const activityListPrevious = () => { return list44000Sprint05(sprint-1) }
const activityList = () => { return list44000Sprint06(sprint) }

const progress = [ 0, 3, 5, 5, 5, 6 ]

// Session 1 of 6: Monday
export const se_6_1of6_PAaA = {
	'prework':[ 
		`All sprint ${sprint-1} assignments are due Sunday!`, '',
		`Be on time and prepared for in-person sprint ${sprint} Planning`,
		'Come Monday with a fully groomed Product Backlog',
		'Make sure that you production application is up and running Monday' ],
	'announcements':[ 
		'Registration starts soon and many of you have a spot reserved in the spring Capstone section cpsc-49200-002',
		'Today is going to be challenging so let’s stay relaxed and stay focused' ],
	'agenda':[ 
		`Sprint ${sprint} Planning as a Class`,
		'Prework for Next Class',
		`Sprint ${sprint} Planning for your Team` ]
}
export const se_6_1of6 = () => { 
	const prework = () => { return tPreworkWithLogo('Prework For Today', se_6_1of6_PAaA.prework, sprint-1, activityListPrevious) }
	const announcements =  () => { return basicSlideWithLogo( 'Announcements', se_6_1of6_PAaA.announcements) }
	const agenda = () => { return agendaSlide(se_6_1of6_PAaA.agenda) }
	const preworkNext = () => { return tPrework('Prework For Next Class', se_6_2of6_PAaA.prework, sprint, activityList) }
	const sprintPlanning = () => {
		return orderedListSlide('Sprint Planning as a Class', `Sprint ${sprint} Expectations:`, [
			'Similar to previous sprints with Discussion, Quiz, Lab, and Reflection',
			'Like sprint 5, the Lab will be in two parts: Planning and Execution', 
			'The Easter Holiday Recess will cause us to miss class next Friday',
			'Similarly, sprint 7 planning will be Wednesday, April 23rd after we return from the break',
			`We will have sprint ${sprint-1} Demos and Retrospective on Friday` ])
	}
	const activitiesReview = () => {
		return basicSlide('Activity List and Assignments Review', [
			'Let’s open our Blackboard shell and briefly review the activity list and assignments together.' ]
		)
	}
	const planningBreakout = () => {
		return orderedListSlide('Sprint Planning Scrum Team Breakout', 'As a scrum team:', [
			`No discussion or breakout today so that we can focus on your Team’s Sprint ${sprint} planning` ]
		)
	}

	const slideDeck = makeSlideDeck([ prework, announcements, agenda, sprintPlanning, activitiesReview, planningBreakout, preworkNext ])
	const slideDeckWithSprintPlanning = insertInto(slideDeck, sprintPlanningSlideDeck(sprint), 8)
	return slideDeckWithSprintPlanning
}

export const se_6_2of6_PAaA = { 
	'prework':[
		`Complete through activity ${progress[2-1]} prior to next class`, '',
		`Be prepared Discussion Board ${sprint}`,
		'Be prepared for Lab & Programming Together' ],
	'announcements':[ 
		'Registration starts Monday... please register for Capstone ASAP',
		'Do you know the capstone section?' ],
	'agenda':[
		'Complete Sprint 6 Planning',
		`Discussion Board ${sprint} as a scrum team`,
		'Review Demo Schedule for Next Class',
		'Lab & Programming Together',
		'Prework for Next Class', ]
}
export const se_6_2of6 = () => {
	const prework = () => { return tPreworkWithLogo('Prework For Today', se_6_2of6_PAaA.prework, sprint-1, activityList) }
	const announcements =  () => { return basicSlideWithLogo( 'Announcements', se_6_2of6_PAaA.announcements) }
	const agenda = () => { return agendaSlide(se_6_2of6_PAaA.agenda) }
	const preworkNext = () => { return tPrework('Prework For Next Class', se_6_2of6_PAaA.prework, sprint, activityList) }
	const reviewDemoSchedule = () => {
		return bulletListSlide('Review Friday’s Demo Schedule', 
			'Let’s review Friday’s demo schedule while recalling that demos are an important part of scrum and that they:', [
			'Occur at the beginning of each new sprint ',
			'Are an opportunity to show what was completed in the previous sprint',
			'Are an **easy** and hopefully rewarding experience to show off your work',
			'Provide a chance to see how others solved a problem and to see some of the challenges they faces' ]
		)
	}
	const discussionBreakout = () => { return tDiscussionBreakout(sprint) } 

	const slideDeck = makeSlideDeck([ prework, announcements, agenda, discussionBreakout, reviewDemoSchedule, preworkNext ])
	const slideDeckWithSprintPlanning = insertInto(slideDeck, sprintPlanningSlideDeck(sprint), 4)
	return slideDeckWithSprintPlanning
}

const se_6_3of6_PAaA = {
	'announcements':[ 
		'Registration starts next week' ],
	'prework':[
		`Complete through activity ${progress[3-1]} prior to next class`, '',
		`Be prepared scrum team sprint ${sprint-1} Demos and Retrospectives` ],
	'agenda':[
		`Sprint ${sprint-1} Demos`,
		`Sprint ${sprint-1} Retrospective`,
		`Breakout for Sprint ${sprint-1} Retrospective`,
		'Prework for Next Class' ]
}
export const se_6_3of6 = () => { 
	const metricsSubmissionPercentage = () => {
		return submissionPercentage([
			{ name: 'Discussion', due:19, submitted:19 },
			{ name: 'Quiz', due:19, submitted:18 },
			{ name: 'Lab', due:19, submitted:19 },
			{ name: 'Reflection', due:19, submitted:19}])
	}
	const retrospective = () => {
		return orderedListSlide('Class Retrospective',
		'Feedback from Assignments & Reflections', [
		`What can I say. You rock!!!... Very good submission percentage.`,
		'Grading is complete and posted',
		'Multiple comments about Configuration Management being harder that coding so far',
		'Reminder that in-person participation in Sprint Planning is required',
		'This is challenging working with teams, and really challenging working with multiple teams' ])
	}
	const scrumTeamDemos = () => {
		return orderedListSlide('Scrum Team Demos',
		'How do/will your team handle Demos?', [
		'What is your team’s “Best-of-the-best” demo' ])
	}
	const scrumTeamRetrospective = () => {
		return orderedListSlide('Scrum Team Retrospective',
		'What will your team need to do to complete Sprint 7 planning on the first day of Sprint 7', [
		'What is the highest priority Continuous Improvement item for your team... will you make it a story in the future?' ])
	}

	const slideDeck = checklistAnnouncementsPreworkAndAgenda(se_6_3of6_PAaA, sprint, activityList)
	const retrospectiveInto = () => { return retrospectiveIntroduction(sprint)}
	const preworkNext = () => { return tPrework('Prework For Next Class', se_6_5of6_PAaA.prework, sprint, activityList) }

	return completeDeck(slideDeck, [sprintDemosIntro,  sprintDemos, demoAssignment, retrospectiveInto, metricsSubmissionPercentage, retrospective, scrumTeamDemos, scrumTeamRetrospective, preworkNext])
}

const se_6_4of6_PAaA = {
	'prework':[
		`Complete through activity ${progress[4-1]} prior to next class`, '',
		'Be prepared breakout session on Metrics' ],
	'announcements':[ 
		`Your team’s required in-person sprint ${sprint+1} planning session it next Monday`, 
		`All sprint ${sprint} assignments due Sunday`],
	'agenda':[
		'Sprint Progress Polling',
		'Metrics Breakout',
		'Prework for Next Class',
		'Lab & Programming Together' ]
}
export const se_6_4of6 = () => {
	const breakout = () => { 
		return breakoutStandard( 
			'Breakout: Metrics', 
			'In this breakout session we will explore Metrics:', [
				'Software Quality, Architecture Quality, and Project Quality',
				'Characteristics of a Good Metric',
				'Common Metrics for Waterfall and Agile',
				'Software Metrics Best Practices',
				'Metics that measure team output including Story Points, Use Case Points, and Function Points',
				'Pros and cons of our Software Engineering team metrics' ]
		)
	}

	const slideDeck = checklistAnnouncementsPreworkAndAgenda(se_6_4of6_PAaA, sprint, activityList)
	const poll = () => { return tPrework('Sprint Progress Polling', se_6_4of6_PAaA.prework, sprint, activityList) }
	const preworkNext = () => { return tPrework('Prework For Next Class', se_6_5of6_PAaA.prework, sprint, activityList) }

	return completeDeck(slideDeck, [poll, breakout, preworkNext, tLab])
}

const se_6_5of6_PAaA = {
	'prework':[
		`Complete through activity ${progress[5-1]} prior to next class`, '',
		`Be prepared for Backlog Grooming in Preparation for Monday’s Sprint ${sprint+1} Planning`,
		'Be prepared for Lab' ],
	'announcements':[ 
		`Required in-person sprint ${sprint+1} planning Monday`,
		`All sprint ${sprint} assignments due Sunday... grace period until Tuesday morning 6 a.m.` ],
	'agenda':[
		'Sprint Progress Polling',
		'Lab / Backlog Grooming',
		'Quiz' ]
}

export const se_6_5of6 = () => { 
	const slideDeck = xyz_n_5of6(sprint, se_6_5of6_PAaA, se_6_6of6_PAaA.prework, activityList)
	insertInto(slideDeck, sprintPlanningSlideDeck(sprint), 5)
	return slideDeck
}

// Session 6 of 6: Friday
const se_6_6of6_PAaA = {
	'announcements':[ 
		`All sprint ${sprint} assignments due Sunday!` ],
	'prework':[
		'Complete through activity 5', '',
		'Be prepared Backlog Grooming' ],
	'agenda':[
		'Sprint Progress Polling',
		'Final Activity List and Assignment Review',
		'Lab: Presentation Expectations plus Backlog Grooming...  suggested sprint 7 capacity is 20 Story Points per team member)' ]
}
export const se_6_6of6 = () => { 
	const slideDeck = xyz_n_6of6(sprint, se_6_6of6_PAaA, se_7_1of6_PAaA.prework, activityList) 
	insertInto(slideDeck, sprintPlanningSlideDeck(sprint), 6)
	return slideDeck
}


